import React from 'react';
import {
    DndContext,
    closestCenter,
    useSensor,
    useSensors,
    PointerSensor,
} from '@dnd-kit/core';
import {
    horizontalListSortingStrategy,
    SortableContext,
    useSortable,
} from '@dnd-kit/sortable';
import {CSS} from '@dnd-kit/utilities';
import s from './../Request/Request.module.scss'
import {onSetRequestPhotos, selectRequestPhotos} from "../../store/requestsReducer";
import {useAppDispatch, useAppSelector} from "../../app/hooks";
import {requestsAPI} from "../../app/api";
import {Popconfirm} from "antd";

function SortableFile({file, index, onOpenViewMode, handleRemoveFile}: any) {
    const {attributes, listeners, setNodeRef, transform, transition} =
        useSortable({id: file.id});

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        display: "inline-block",
        cursor: "grab",
        border: "1px solid #f0f0f0",
        width: "167px",
        height: "167px",
        borderRadius: "2px",
        padding: "8px",
        margin: "8px",
    }

    const handleConfirm = (id: number) => {
        handleRemoveFile(id);
    }

    return (
        <div ref={setNodeRef} style={style} {...attributes} >
            <div style={{
                position: 'relative',
                height: '100%'
            }} {...listeners}>
                {file.format !== "mp4" && file.format !== "mov" && file.format !== "avi" && file.format !== "MOV" ? (
                    <img
                        src={`data:image/${file.format};base64,${file.photo}`}
                        alt={file.name}
                        style={{
                            objectFit: "contain",
                            borderRadius: 4,
                            width: "100%",
                            height: "100%",
                        }}
                    />
                ) : (
                    <video width={167} height={167} style={{borderRadius: 4}}>
                        <source
                            src={`data:video/mp4;base64,${file.photo}`}
                            type={`video/mp4`}
                        />
                    </video>
                )}
            </div>
            <div className={s.uploader__hoveredBlock} data-no-dnd="true">
                <button onClick={(e) => {
                    e.stopPropagation();
                    onOpenViewMode(index)
                }}
                        className={s.uploader__deleteBtn} data-no-dnd="true">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                         viewBox="0 0 16 16" fill="none">
                        <path
                            d="M15.6822 7.54028C13.9894 3.97421 11.4305 2.17957 8.0001 2.17957C4.56796 2.17957 2.01082 3.97421 0.31796 7.54207C0.250059 7.68585 0.214844 7.84288 0.214844 8.00189C0.214844 8.16089 0.250059 8.31793 0.31796 8.46171C2.01082 12.0278 4.56975 13.8224 8.0001 13.8224C11.4322 13.8224 13.9894 12.0278 15.6822 8.45992C15.8197 8.17064 15.8197 7.83492 15.6822 7.54028ZM8.0001 12.5367C5.11975 12.5367 3.01082 11.076 1.52332 8.00099C3.01082 4.92599 5.11975 3.46528 8.0001 3.46528C10.8805 3.46528 12.9894 4.92599 14.4769 8.00099C12.9912 11.076 10.8822 12.5367 8.0001 12.5367ZM7.92867 4.85814C6.19296 4.85814 4.78582 6.26528 4.78582 8.00099C4.78582 9.73671 6.19296 11.1439 7.92867 11.1439C9.66439 11.1439 11.0715 9.73671 11.0715 8.00099C11.0715 6.26528 9.66439 4.85814 7.92867 4.85814ZM7.92867 10.001C6.82332 10.001 5.92867 9.10635 5.92867 8.00099C5.92867 6.89564 6.82332 6.00099 7.92867 6.00099C9.03403 6.00099 9.92867 6.89564 9.92867 8.00099C9.92867 9.10635 9.03403 10.001 7.92867 10.001Z"
                            fill="white"/>
                    </svg>
                </button>
                <Popconfirm
                    title="Delete this request?"
                    description="This action cannot be undone."
                    onConfirm={() => handleConfirm(file.id)}
                    okText="Yes"
                    cancelText="No"
                    okType="danger"
                >
                    <button className={s.uploader__deleteBtn}
                            data-no-dnd="true">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                             viewBox="0 0 16 16" fill="none">
                            <path
                                d="M5.28544 2.14118H5.14258C5.22115 2.14118 5.28544 2.0769 5.28544 1.99833V2.14118H10.714V1.99833C10.714 2.0769 10.7783 2.14118 10.8569 2.14118H10.714V3.4269H11.9997V1.99833C11.9997 1.36797 11.4872 0.855469 10.8569 0.855469H5.14258C4.51222 0.855469 3.99972 1.36797 3.99972 1.99833V3.4269H5.28544V2.14118ZM14.2854 3.4269H1.71401C1.39794 3.4269 1.14258 3.68225 1.14258 3.99833V4.56976C1.14258 4.64833 1.20686 4.71261 1.28544 4.71261H2.36401L2.80508 14.0519C2.83365 14.6608 3.33722 15.1412 3.94615 15.1412H12.0533C12.664 15.1412 13.1658 14.6626 13.1944 14.0519L13.6354 4.71261H14.714C14.7926 4.71261 14.8569 4.64833 14.8569 4.56976V3.99833C14.8569 3.68225 14.6015 3.4269 14.2854 3.4269ZM11.9158 13.8555H4.08365L3.65151 4.71261H12.3479L11.9158 13.8555Z"
                                fill="white"/>
                        </svg>
                    </button>
                </Popconfirm>
            </div>
        </div>
    );
}

export default function ImageSorter(props: any) {
    const fileListFromServer = useAppSelector(selectRequestPhotos) // you can keep fileListFromServer static and update fileList
    const dispatch = useAppDispatch()
    const sensors = useSensors(useSensor(PointerSensor));


    const handleDragEnd = (event: any) => {
        const {active, over} = event;
        if (active.id !== over?.id) {
            const sorted = [...fileListFromServer].sort((a, b) => a.order - b.order);
            const activeItem = sorted.find((item) => item.id === active.id);
            const overItem = sorted.find((item) => item.id === over.id);
            if (!activeItem || !overItem) return;
            const reordered = fileListFromServer.map((item) => {
                if (item.id === activeItem.id) {
                    return {...item, order: overItem.order};
                } else if (item.id === overItem.id) {
                    return {...item, order: activeItem.order};
                }
                return item;
            });
            dispatch(onSetRequestPhotos(reordered.sort((a, b) => a.order - b.order)));
            requestsAPI.updatePhotoRankOrder(Number(active.id), {
                old_index: activeItem.order,
                new_index: overItem.order,
            });
        }
    };

    return (
        <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
            <SortableContext items={fileListFromServer!?.map((f: any) => f.id)}
                             strategy={horizontalListSortingStrategy}>
                {fileListFromServer!?.map((file: any, index: any) => (
                    <SortableFile
                        key={file.id}
                        file={file}
                        index={index}
                        onOpenViewMode={props.onOpenViewMode}
                        handleRemoveFile={props.handleRemoveFile}
                    />
                ))}
            </SortableContext>
        </DndContext>
    );
}
